const ctaBackgroundColors: Record<string, string> = {
  "fern-100": "bg-secondary-100",
  "fern-200": "bg-secondary-200",
  "putty-500": "bg-putty-500",
  "putty-200": "bg-putty-200",
};

export { ctaBackgroundColors };
